<template>

  <!-- eslint-disable  -->

  <div class="w-full" v-if="this.$store.state.fetchNewsComplete == true">

    <div class="m-2 lg:m-8">

      <div class="">

        <h1 class="text-gray-900 text-4xl text-left mb-4"> News & Veranstaltungen </h1>

        <p> {{ upcoming() }} </p>

        <div  class="flex flex-wrap mb-16">

          <div class="card pb-4 sm:p-1 lg:p-2 flex flex-wrap w-full sm:w-1/2 lg:w-1/3" :key="index.titel" v-for="index in sortNews"
          v-if="actualDate <= index.datum_abschalten && actualDate >= index.datum_aufschalten">

          <div class="rounded-lg overflow-hidden bg-blue-100 text-left w-full sm:m-0 p-2 sm:p-0">

            <div v-if="index.bild" class="mb-2">

              <img class="shadow-inner rounded-b-none w-full h-64 object-cover " :src="index.bild.url" alt="">

            </div>

            <div v-else class="mb-2">

              <img class="w-full rounded-b-none shadow-inner h-64 object-cover" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/keyvisual_placeholder_blue.png" alt="">

            </div>

            <!-- Bild Ende -->

            <div class="p-3">


              <p class="font-thin text-base text-gray-800"> {{ convert(index.datum_aufschalten) }} </p>

              <h1 v-if="index.titel.length < 30" class="text-blue-700 mb-2 h-8"> {{index.titel}}</h1>

              <h1 v-else class="text-blue-700 mb-2 text-base h-8"> {{index.titel}}</h1>

              <div class="" v-html="index.inhalt"> </div>

              <div v-if="index.download !== false" class="mt-4">

                <a v-if="index.downloadtext !=='' " :href="index.download.url" target="_blank" class="text-left text-base text-blue-600 cursor-pointer no-underline"> <i class="fa fa-download" aria-hidden="true"></i> {{ index.downloadtext }} </a>

                <a v-else :href="index.download.url" target="_blank" class="text-left text-base text-blue-600 cursor-pointer no-underline"> <i class="fa fa-download" aria-hidden="true"></i> {{ index.download.title }} </a>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>


    <div class="">

      <h1 class="text-gray-900 text-4xl text-left mb-4"> Vergangenes </h1>

      <div  class="flex flex-wrap mb-16 ">

        <div class="card pb-4 sm:p-1 lg:p-2 flex flex-wrap w-full sm:w-1/2 lg:w-1/3" :key="index.titel" v-for="index in sortNews"
        v-if="actualDate > index.datum_abschalten && index.archivieren == true">

        <div class="bg-blue-100 shadow-md rounded-lg text-left w-full sm:m-0 p-2 sm:p-0">

          <div v-if="index.bild" class="mb-2">

            <img class="shadow-inner rounded-b-none w-full h-64 object-cover " :src="index.bild.url" alt="">

          </div>

          <div v-else class="mb-2">

            <img class="w-full rounded-b-none shadow-inner h-64 object-cover" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/keyvisual_placeholder_blue.png" alt="">

          </div>

          <!-- Bild Ende -->

          <div class="p-3">


            <p class="font-thin text-base text-gray-800"> {{ convert(index.datum_aufschalten) }} </p>

            <h1 v-if="index.titel.length < 30" class="text-blue-700 mb-2 h-8"> {{index.titel}}</h1>

            <h1 v-else class="text-blue-700 mb-2 text-base h-8"> {{index.titel}}</h1>

            <div class="" v-html="index.inhalt"> </div>

            <div v-if="index.download !== false" class="mt-4">

              <a v-if="index.downloadtext !=='' " :href="index.download.url" target="_blank" class="text-left text-base text-blue-600 cursor-pointer no-underline"> <i class="fa fa-download" aria-hidden="true"></i> {{ index.downloadtext }} </a>

              <a v-else :href="index.download.url" target="_blank" class="text-left text-base text-blue-600 cursor-pointer no-underline"> <i class="fa fa-download" aria-hidden="true"></i> {{ index.download.title }} </a>

            </div>

          </div>
        </div>

      </div>

    </div>

  </div>

</div>

</div>
</template>

<script>

export default {
  components: {

  },
  name: 'News',
  props: {

  },
  data() {
    return {

      actualYear: '',
      actualDate: '',

    }
  },
  methods: {

    upcoming(){

      var upcoming = [];

      // console.log(this.$store.state.news);

      var i;
      for (i = 0; i < this.$store.state.news.length; i++) {

        if (this.actualDate <= this.$store.state.news[i].datum_abschalten && this.actualDate >= this.$store.state.news[i].datum_aufschalten){

          // upcoming events go in here
          upcoming.push(true)
          // console.log("ONE IS TRUE");

        } else {

          // console.log("ONE IS FALSE");

        }

      }

      if (upcoming.length > 0){

        return " ";

      } else {

        return "Momentan gibt es keine News und keine bevorstehenden Veranstaltungen.";

      }

    },

    convert(old){

      // console.log("nodedate:" + old);

      var monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"];

      // console.log(old)

      var yyyy = old.slice(0, 4)
      // console.log("Actual:" + yyyy);
      // console.log("This:" + this.actualYear)

      var mm = old.slice(4, 6)
      mm = parseInt(mm)

      var dd = old.slice(6, 8)

      if (yyyy == this.actualYear){
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      } else {
        return (dd + ". " + monthNames[mm-1] + " " + yyyy);
      }
    },

    getdate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();

      // console.log(today = dd + '. ' + monthNames[mm] + ' ' + yyyy);

      this.actualYear = yyyy;
      this.actualDate = yyyy + mm + dd

      // console.log("DATUM IST" + this.actualDate);
    },

    compare(a, b) {
      if (a.datum_aufschalten > b.datum_aufschalten) {
        return -1;
      }
      if (a.datum_aufschalten < b.datum_aufschalten) {
        return 1;
      }
      // a muss gleich b sein
      return 0;
    },

  },
  mounted: function(){

    this.getdate();

  },

  computed: {

    sortNews() {

      // console.log(this.data.slice().sort(this.compare));
      return this.$store.state.news.slice().sort(this.compare);
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

image{

  border-radius: 10px !important;
}

.border-box{
  box-sizing: border-box !important;
}


.mt-auto {
  margin-top: auto;
}

.image-auto {
  width: 100%;
  height: auto;
}

.spinner-big{
  font-size: 5rem;
  text-align: center !important;
}

.container {
  position: relative;
}

.image {
  opacity: 1;
  /* display: block; */
  transition: .5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.card:hover .image {
  opacity: 0.3;
}

.card:hover .middle {
  opacity: 1;
}

.card {
  // max-height: 50vh;
  overflow: hidden;
}

.text {
  font-size: 16px;
  padding: 16px 32px;
}


</style>
